import React from 'react';
import { Card, Typography, List, Statistic, Row, Col, Tag } from 'antd';
import { MarketInsightsData } from '../../../types/api';

const { Title, Paragraph } = Typography;

interface MarketInsightsResearchProps {
    marketInsights: MarketInsightsData;
}

export const MarketInsightsResearch: React.FC<MarketInsightsResearchProps> = ({ marketInsights }) => {
    return (
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
            <Card bordered={false} style={{ borderRadius: 12, marginBottom: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                <Title level={2} style={{ color: '#2c3e50', borderBottom: '2px solid #4a90e2', paddingBottom: 12 }}>💎 Market Value Estimate</Title>
                <div style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    padding: 24,
                    borderRadius: 8,
                    textAlign: 'center',
                    margin: '20px 0',
                    fontSize: '1.75rem',
                    fontWeight: 700,
                    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
                }}>
                    {marketInsights.price_recommendation}
                </div>

                <Card style={{ background: '#f8f9fa', borderRadius: 8, margin: '20px 0' }}>
                    <Title level={3} style={{ color: '#2c3e50' }}>📊 Comparable Listings</Title>
                    <List
                        itemLayout="horizontal"
                        dataSource={[
                            { title: 'Sold Listings', content: marketInsights.listings_summary.sold_summary },
                            { title: 'Active Listings', content: marketInsights.listings_summary.active_summary }
                        ]}
                        renderItem={(item, index) => (
                            <List.Item style={{ borderBottom: index === 0 ? '1px solid #e1e4e8' : 'none', paddingBottom: index === 0 ? 16 : 0, marginBottom: index === 0 ? 16 : 0 }}>
                                <div style={{ fontWeight: 600, color: '#444', marginRight: 15 }}>{item.title}</div>
                                <Paragraph style={{ color: '#555', marginTop: 10 }}>{item.content}</Paragraph>
                            </List.Item>
                        )}
                    />
                </Card>

                <Row gutter={16} style={{ margin: '20px 0' }}>
                    <Col xs={24} md={12}>
                        <Card>
                            <Statistic title="Avg. Sold Price" value={marketInsights.market_stats.avg_price_sold} valueStyle={{ color: '#2c3e50', fontWeight: 700 }} />
                        </Card>
                    </Col>
                    <Col xs={24} md={12}>
                        <Card>
                            <Statistic title="Avg. Mileage" value={marketInsights.market_stats.avg_mileage_sold} valueStyle={{ color: '#2c3e50', fontWeight: 700 }} />
                        </Card>
                    </Col>
                </Row>
            </Card>

            <Card bordered={false} style={{ borderRadius: 12, marginBottom: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                <Title level={2} style={{ color: '#2c3e50', borderBottom: '2px solid #4a90e2', paddingBottom: 12 }}>⚖️ Factors Impacting Value</Title>
                <Row gutter={32}>
                    <Col xs={24} md={12}>
                        <Title level={3}><Tag color="success">✓ Positives</Tag></Title>
                        <List
                            dataSource={marketInsights.market_factors.positives}
                            renderItem={item => <List.Item style={{ background: '#f8f9fa', borderLeft: '4px solid #27ae60', padding: '14px 16px', borderRadius: 4, marginBottom: 12 }}>{item}</List.Item>}
                        />
                    </Col>
                    <Col xs={24} md={12}>
                        <Title level={3}><Tag color="error">⚠ Negatives</Tag></Title>
                        <List
                            dataSource={marketInsights.market_factors.negatives}
                            renderItem={item => <List.Item style={{ background: '#f8f9fa', borderLeft: '4px solid #e74c3c', padding: '14px 16px', borderRadius: 4, marginBottom: 12 }}>{item}</List.Item>}
                        />
                    </Col>
                </Row>
            </Card>

            <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                <Title level={2} style={{ color: '#2c3e50', borderBottom: '2px solid #4a90e2', paddingBottom: 12 }}>💡 Pricing Insights & Trends</Title>
                <Paragraph>
                    {marketInsights.pricing_insights}
                </Paragraph>
            </Card>
        </div>
    );
};
